









































































































import { Component, Vue } from 'vue-property-decorator';
import { InvoiceViewModel } from '@/services/api/nswag/stapiclient_generated';
import { stInvoiceApi } from '@/services/st-api';

@Component({
  components: {},
})
export default class InvoiceExport extends Vue {
  id: number = 0;
  model: InvoiceViewModel = InvoiceViewModel.fromJS({});

  created() {
    if (this.$route.params.id) {
      this.id = parseInt(this.$route.params.id);
    }
  }

  async mounted() {
    this.model = await stInvoiceApi.getInvoice(this.id);
  }
}
